import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import i18n from '../../i18next';

const ResendOrdersResultsModal = props => {

    const { modalBodyStyles } = styles;

    return (
        <Modal isOpen={props.isOpen} toggle={props.toggle}>
            <ModalHeader toggle={props.toggle}>{i18n.t('screens:systemControlContainer.modalMsg')}:</ModalHeader>
            <ModalBody style={modalBodyStyles}>
                <p>{props.resendOrders}</p>
            </ModalBody>
            <ModalFooter>
                <Button color='primary' onClick={props.toggle}>{i18n.t('common:buttons.close')}</Button>
            </ModalFooter>
        </Modal>
    );
}

export default ResendOrdersResultsModal;

const styles = {
    modalBodyStyles: {
        maxHeight: 450,
        overflowY: 'auto'
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/ResendOrdersResultsModal.js